import { useQuery } from 'react-query'
import { IFilter } from 'src/components/filter/types/filter.types'
import { QUERY_KEYS } from 'src/constants'
import { userService } from 'src/services/user.service'

const initialFilter = { sortBy: 'created_at', sortingOrder: 'DESC' }

const useGetUserReferrals = (filter?: IFilter) => {
  return useQuery(
    [QUERY_KEYS.USER_REFERRALS, filter ?? initialFilter],
    () => userService.getUserReferrals(filter ?? {}),
    { keepPreviousData: true },
  )
}

export { useGetUserReferrals }
